// eslint-disable-next-line import/prefer-default-export
export function numberWithCommas(value) {
  if (value === null || value === undefined) {
    return 0;
  }
  const parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts.join(',');
}
